<template>
  <VDropdown
    v-if="showTourtip"
    :popper-class="['bookmark-tour-tooltip', `popover-${sequence}`, ...classes].join(' ')"
    :shown="true"
    :placement="placement"
    :auto-hide="false"
    :delay="{ show: delay }"
    :distance="offset"
  >
    <slot />
    <template #popper>
      <span class="step-counter">
        {{ sequence }} of {{ totalTooltips }}
      </span>
      <div
        class="text"
        v-html="text"
      />
      <router-link
        v-if="sequence === 5"
        :to="{ name: 'home' }"
        class="home-button"
      >
        <icon
          name="home"
          variant="white"
        />Go Home
      </router-link>
    </template>
  </VDropdown>
</template>

<script>
import Icon from '@components/singletons/icon';

import { bookmarkTooltips, getClassTourConfig } from '@/utils/tour';

export default {
  components: { Icon },
  props: {
    classes: {
      type: Array,
      default: () => [],
    },
    sequence: {
      type: Number,
      default: null,
    },
    overrideOntour: {
      type: Boolean,
      default: false,
    },
    delay: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    searchTerm() {
      const config = getClassTourConfig(this.$store);
      if (config && config.query) {
        return config.query;
      }
    },
    offset() {
      if (this.sequence === 4) {
        return 30;
      }
    },
    placement() {
      if (this.sequence === 4 && this.classes.length > 0) {
        return 'bottom';
      } else {
        return this.tooltip.placement;
      }
    },
    showTourtip() {
      if (this.overrideOntour) return true;
      const onTour = this.$store.getters['session/onTour'];
      const tourType = this.$store.getters['session/tourType'];
      return onTour && tourType === 'bookmark';
    },
    text() {
      return this.tooltip.text[this.$store.getters['session/userClass']] || this.tooltip.text.default;
    },
    tooltip() {
      return bookmarkTooltips(this.searchTerm)[this.tooltipIndex];
    },
    tooltipIndex() {
      return this.sequence - 1;
    },
    totalTooltips() {
      return bookmarkTooltips().length;
    },
  },
};
</script>

<style lang="scss">

.bookmark-tour-tooltip {
  // Default styles from the docs, modified slightly
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background-color: #001c74;
    border-radius: rem-calc(8);
    padding: rem-calc(16) rem-calc(24);
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #001c74;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 10px;

    .tooltip-arrow {
      border-width: 10px 10px 0 10px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -10px;
      left: calc(50% - 10px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 10px 10px 10px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -10px;
      left: calc(50% - 10px);
      margin-top: 0;
      margin-bottom: 0;
    }

    &.popover-2 {
      .tooltip-arrow {
        left: 15px !important;
      }
    }
  }

  &[x-placement^="right"] {
    margin-left: 10px;

    .tooltip-arrow {
      border-width: 10px 10px 10px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -10px;
      top: calc(50% - 10px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 10px;

    .tooltip-arrow {
      border-width: 10px 0 10px 10px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -10px;
      top: calc(50% - 10px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="none"] {
    margin-right: 5px;
    right: 300px !important;
    bottom: 500px !important;
    top: auto !important;
    left: auto !important;

    @include breakpoint(small) {
      right: 15px !important;
      bottom: 350px !important;
    }

    .tooltip-arrow {
      display: none;
    }
  }

  &.popover {
    .popover-inner {
      box-shadow: 0 5px 30px rgba(black, .1);
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
  // End default styles from docs

  &.popover-4 {
    &:not(.mobile-menu-popover) {
      @include breakpoint(small) {
        display: none !important;
      }
    }

    &.mobile-menu-popover {
      display: none !important;

      @include breakpoint(small) {
        display: block !important;
      }
    }
  }

  .home-button {
    align-items: center;
    background: #00d8f8;
    border-radius: 24px;
    display: flex;
    font-weight: $semi-bold;
    margin: rem-calc(20) auto rem-calc(12) auto;
    padding: rem-calc(10) rem-calc(28);
    text-decoration: none !important;
    width: rem-calc(100);

    img {
      height: rem-calc(14);
      margin-right: rem-calc(8);
      width: rem-calc(14);
    }
  }

  .step-counter {
    color: #ffe980;
    font-size: rem-calc(12)
  }

  .text {
    line-height: 1.25;
  }

  .highlight {
    color: #ffe980;
    font-weight: $semi-bold;
  }
}

</style>
